<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :starting-stock-balance="form.balance"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in mainLabels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchema[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <Sublist subtitle="Характеристики">
        <template slot="fields">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in characterLabels"
                :key="index"
                v-if="value !== 'Материал'"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchema[key])"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <input
                    class="form-control"
                    placeholder="Отсутствует"
                    :name="key"
                    :maxlength="maxLength[key]"
                    :disabled="actionType === 'read'"
                    v-model.trim="form[key]"
                  />
                </fieldset>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="col-lg-6">
                <label>Материал</label>
                <textarea
                  class="form-control"
                  :disabled="actionType === 'read'"
                  :maxlength="maxLength.material"
                  placeholder="Отсутствует"
                  v-model.trim="form.material"
                />
              </div>
            </div>
          </div>
        </template>
      </Sublist>
      <div class="col-lg-6">
        <label class="control-label">
          Изображение
          <span v-if="actionType !== 'read'" class="field__label_required">
            *
          </span>
        </label>
        <ImageInput
          :preview-image="previewImage"
          :only-preview-image="actionType === 'read'"
          @on-select-file="setImage"
          @on-delete="deleteImage"
        />
      </div>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import schemas from "@/stock/validation-schemas";
import { stockComponentService } from "@/stock/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import Form from "@/_shared/widgets/Form";
import ImageInput from "@/_shared/features/form/ImageInput";

import { useForm, useNotification, useImageField } from "@/_shared/mixins";
import { formsFields } from "@/stock/constants";

import { objectHelper } from "@/_shared/utils";
const { createCopy, createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
    useImageField,
  ],
  components: {
    Form,
    Sublist,
    ImageInput,
  },
  data() {
    return {
      fallbackLink: "/sewing_accessories",
      entityName: {
        readonly: "Фурнитура",
        modify: "фурнитуры",
      },
      form: createFromKeys(formsFields.sewingAccessory.labels),
    };
  },
  validations() {
    return {
      form: this.validationSchema,
    };
  },
  async created() {
    const addingFields = createCopy(this.form);
    const callback = stockComponentService.get("sewing_accessories");
    await this.setFormFields(addingFields, callback).then(() => {
      this.checkPreviewImageExistence();
    });
  },
  computed: {
    maxLength() {
      return formsFields.sewingAccessory.maxlength;
    },
    validationSchema() {
      return schemas.sewingAccessory;
    },
    mainLabels() {
      const { name, type, barcode, vendor_code } = formsFields.sewingAccessory.labels;
      return { name, type, barcode, vendor_code };
    },
    characterLabels() {
      const { color, length, width, size, thickness, material } =
        formsFields.sewingAccessory.labels;
      return {
        color,
        length,
        width,
        size,
        thickness,
        material,
      };
    },
  },
  methods: {
    async submit() {
      const callback = async () => {
        return await this.prepareImage()
          .then(async (image) => {
            return await stockComponentService[this.actionType](
              this.form, "sewingAccessory", image,
            );
          })
          .catch((error) => {
            throw new Error(error.message);
          });
      };
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/stock/pages/SewingAccessoryForm.vue